<mat-card *ngIf="urlaubstermin" [style.background]="farben[urlaubstermin.KENNZEICHEN]">
  <mat-card-content>
    {{ urlaubstermin.KENNZEICHEN | titlecase }}
  </mat-card-content>
</mat-card>
